import CommonAppbar from '../components/common/CommonAppbar';
import * as React from 'react';
import {useMemo, useState} from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import {getCategories} from '../mockData/question';
import Typography from '@mui/material/Typography';
// import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import DoneIcon from '@mui/icons-material/Done';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import {useNavigate} from 'react-router-dom';
import {URLS} from '../constants/appConstants';
import DeveloperInfo from '../components/common/DeveloperInfo';
import Divider from '@mui/material/Divider';

export default function Categories() {

  const categories = useMemo(() => getCategories(), [])
  const [selectedCategories, setSelectedCategories] = useState([])

  const navigate = useNavigate();

  const handleClick = (label) => {
    setSelectedCategories([...selectedCategories, label])
  }

  const handleRemoveClick = (label) => {
    const selectedCategoriesTemp = [...selectedCategories]
    const index = selectedCategoriesTemp.indexOf(label)
    if (index > -1) {
      selectedCategoriesTemp.splice(index, 1);
    }
    setSelectedCategories(selectedCategoriesTemp)
  }
  return <>
    <CommonAppbar isMainPage={false} pageHeader={`Interests`}/>
    <DeveloperInfo> Selection is optional. User can skip this step. Interests from all topics should be visible to
      users. </DeveloperInfo>
    <Typography variant="h6" component="h6" textAlign={'center'} sx={{mt: 2}}>
      Select your favourite interests
    </Typography>
    <Box sx={{textAlign: 'center', mt: 2}}>
      {categories.map(category => {
        const {label, icon} = category
        const isSelected = selectedCategories.includes(label)

        if (isSelected) {
          return <Chip sx={{ml: 1, mt: 1}} color={'info'} label={label}
                       onClick={() => handleRemoveClick(label)}
            // avatar={icon}
                       deleteIcon={<DoneIcon/>}
                       onDelete={() => handleRemoveClick(label)}
          />
        }
        return <Chip sx={{ml: 1, mt: 1}}
                     color={'info'}
                     variant={'outlined'}
                     label={label}
                     onClick={() => handleClick(label)}
          // avatar={icon}
                     deleteIcon={<AddIcon/>}
                     onDelete={() => handleRemoveClick(label)}
        />
      })}
    </Box>
    <Divider/>
    <Box sx={{mt: 2, textAlign: 'center'}}>
      <Button variant="outlined" sx={{mr: 2}} onClick={() => navigate(URLS.HOME)}>Skip</Button>
      <Button variant="contained" onClick={() => navigate(URLS.HOME)}>Save</Button>
    </Box>


  </>
}
